/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { FileType } from '../models/file-type';
import { GetFileRequestResponse } from '../models/get-file-request-response';

/**
 * file request
 */
@Injectable({ providedIn: 'root' })
export class FileRequestService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAllFileRequests()` */
  static readonly GetAllFileRequestsPath =
    '/api/v1/async-file-download-requests';

  /**
   * Get list of file requests.
   *
   * Gets the list of all the file requests. <br>
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllFileRequests()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllFileRequests$Response(
    params?: {
      /**
       * the page number.
       */
      page?: number;

      /**
       * the size of a page
       */
      size?: number;

      /**
       * sort
       */
      sort?: string;

      /**
       * This adds a filter to the client list
       *  - business type
       */
      fileByType?: FileType;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<GetFileRequestResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      FileRequestService.GetAllFileRequestsPath,
      'get'
    );
    if (params) {
      rb.query('page', params.page, {});
      rb.query('size', params.size, {});
      rb.query('sort', params.sort, {});
      rb.query('fileByType', params.fileByType, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GetFileRequestResponse>;
        })
      );
  }

  /**
   * Get list of file requests.
   *
   * Gets the list of all the file requests. <br>
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllFileRequests$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllFileRequests(
    params?: {
      /**
       * the page number.
       */
      page?: number;

      /**
       * the size of a page
       */
      size?: number;

      /**
       * sort
       */
      sort?: string;

      /**
       * This adds a filter to the client list
       *  - business type
       */
      fileByType?: FileType;
    },
    context?: HttpContext
  ): Observable<GetFileRequestResponse> {
    return this.getAllFileRequests$Response(params, context).pipe(
      map(
        (
          r: StrictHttpResponse<GetFileRequestResponse>
        ): GetFileRequestResponse => r.body
      )
    );
  }

  /** Path part for operation `getReportById()` */
  static readonly GetReportByIdPath =
    '/api/v1/async-file-download-requestsf/{id}';

  /**
   * To download report using file request id.
   *
   * download the report using file request id. <br>
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getReportById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getReportById$Response(
    params: {
      /**
       * The zatca invoice's id that needs to be fetched
       */
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Blob>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      FileRequestService.GetReportByIdPath,
      'get'
    );
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'blob', accept: 'application/*', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<Blob>;
        })
      );
  }

  /**
   * To download report using file request id.
   *
   * download the report using file request id. <br>
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getReportById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getReportById(
    params: {
      /**
       * The zatca invoice's id that needs to be fetched
       */
      id: number;
    },
    context?: HttpContext
  ): Observable<Blob> {
    return this.getReportById$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }
}
